<template>
  <order-item-list v-if="config.order_feature == 1"></order-item-list>
  <div v-else-if="config.order_feature == 0">
    <vx-card><h2>This is for Go Check In full version, please contact us for more info at <b>832-968-6668</b></h2></vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>

<script>
import ItemList from "../../components/order/ItemList";
export default {
  props: {
    dataChange: {
      type: Object
    }
  },
  components: {
    "order-item-list": ItemList
  },
  created() {},
  destroyed() {},
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  data() {
    return {
      isOpenLoading: false
    };
  },
  // watch: {
  //   config: {
  //     immediate: true,
  //     deep: true,
  //     handler() {
  //       if(this.config && this.config.order_feature != 0 && this.config.order_feature != 1) {
  //         this.openLoadingInDiv();
  //       } else {
  //         this.closeLoading();
  //       }
  //     }
  //   },
  // },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Get data failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
  }
};
</script>
